export default {
    getPlans: { method: 'get', url: 'emcadmin/plans' },
    postPlans: { method: 'post', url: 'emcadmin/plans' },
    putPlans: { method: 'put', url: 'emcadmin/plans/{id}' },
    deletePlans: { method: 'delete', url: 'emcadmin/plans/{id}' },
}
